import React, { FC } from 'react'
import styles from './LayoutsButton.module.scss'
import Icon, { IconType, iconName } from '@bt-react/components/Icon'
import classnames from 'classnames'
import { LayoutType } from '../../../dataStore/slices/layouts/layoutsSlice'

interface LayoutsButtonProps {
  layoutsMenuOpen: boolean
  activeLayoutType: LayoutType
  layoutsBtnClick: () => void
}

const getActiveLayoutIcon = (layoutType: LayoutType): iconName => {
  if (layoutType === LayoutType.Full) return IconType.iconName.layoutFullSmall
  if (layoutType === LayoutType.Sidebar) return IconType.iconName.layoutSidebarSmall
  if (layoutType === LayoutType.Split) return IconType.iconName.layoutSplitSmall
  return IconType.iconName.layoutGridSmall
}

const LayoutsButton: FC<LayoutsButtonProps> = ({
  layoutsMenuOpen,
  activeLayoutType,
  layoutsBtnClick
}) =>
  <div
    data-bdd={'layouts-button'}
    onClick={layoutsBtnClick}
    className={classnames(styles['layouts-btn'], {
      [styles['layouts-btn--menu-open']]: layoutsMenuOpen
    })}>
    <Icon
      name={getActiveLayoutIcon(activeLayoutType)}
      dataBdd={`layouts-icon-${activeLayoutType}`}
      className={styles['layouts-btn-svg']}
    />
    Change Layout
    <Icon
      name={IconType.iconName.angleUp}
      className={styles['layouts-btn-arrow']}
    />
  </div>

export default LayoutsButton